import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SambaUploderService } from 'src/app/pages/gestao/content/shared/file/samba-uploader/samba-uploader.service';
import { UsersMeService } from 'src/app/pages/gestao-usuarios/users/users-me.service';

const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json;charset=UTF-8',
		'Accept-Language': '1',
	}),
	observe: 'response' as 'body'// to display the full response & as 'body' for type cast
};


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
	private currentUserSubject: BehaviorSubject<any>;
	public currentUser: Observable<any>;

	constructor(
		private http: HttpClient,
		private sambaUploaderService: SambaUploderService,
    	private usersMeService: UsersMeService
	) {
		this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue() {
		return this.currentUserSubject.value;
	}

	public get currentUserValueFP() {
		return localStorage.getItem('finger');
	}

	isLoggedIn() {		
		if (this.currentUserSubject.value == null) {
			return false;
		}		
		return true;
	}

	login(username: string, password: string, fingerprint: string, admin: boolean) {
		return this.http.post<any>(`${environment.loginApi}/login`, { username, password, admin, fingerprint }, httpOptions)
			.pipe(
				map((response) => {
					const user = {
						token: response.headers.get('Authorization')
					};

					if (user.token) {
						// store user details and jwt token in local storage to keep user logged in between page refreshes
						localStorage.setItem('currentUser', JSON.stringify(user));
						// passa o fingerprint para o inteceptor
						localStorage.setItem('finger', fingerprint);
						
						this.currentUserSubject.next(user);

						this.getCurrentUserMe();
					}

					return user;
				})
			);
	}

	getCurrentUserMe() {
		this.usersMeService.getCurrentUsersMe().subscribe(currentUsersMe => {
			const user = {
				...this.currentUserValue,
				name: currentUsersMe.name,
				role: currentUsersMe.roles[0],
				expires: currentUsersMe.expires,
				id: currentUsersMe.id,
				email: currentUsersMe.username,
				idAccount: currentUsersMe.accountId,
			}

			localStorage.setItem('currentUser', JSON.stringify(user));

			this.currentUserSubject.next(user);
		});
  	}

	refresh() {
		return this.http.post<any>(`${environment.loginApi}/users/refresh`, { }, httpOptions)
			.pipe(
				map((response) => {
					const token = response.headers.get('Authorization');
					if (token) {
						const user = {
							...this.currentUserValue,
							token
						}

						localStorage.setItem('currentUser', JSON.stringify(user));

						this.currentUserSubject.next(user);
					}
				})
			);
	}

	logout() {
		// remove user from local storage to log user out
		localStorage.removeItem('currentUser');
		localStorage.removeItem('finger');
		this.currentUserSubject.next(null);
		this.sambaUploaderService.set(false);
	}

	requestPasswordChange(email: string): Observable<any> {
		return this.http.put(`${environment.apiURL}/accounts/challenge/password-reset`, { email: email }, httpOptions)
	}


	postLastUrl(url){
		return this.http.post<any>(`${environment.apiURL}/url/report`, {url: url})
	}
	getLastUrl(){
		return this.http.get<any>(`${environment.apiURL}/url/report`);
	}
}
